import React from "react";

import { useTimerTime } from "./TimerContext";

const TimerDisplay = () => {
	const time = useTimerTime();
	return <h5 style={{textAlign:'center'}}>Time: {Math.round(time/100)/10} sec</h5>;
};

export default TimerDisplay;
